import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import { ExportComponent } from 'src/app/pages/claims/dialogs/export/export.component';
import { ClaimService } from 'src/app/services/claim.service';
import { defaultSSPClaimsTable, IClaims_Table } from '../../models/claim-list.interface';

@Component({
  selector: 'upsc-claim-search',
  templateUrl: './claim-search.component.html',
  styleUrls: ['./claim-search.component.scss']
})
export class ClaimSearchComponent implements OnInit {
  @Output() searchParams = new EventEmitter<any>();

  //Show/hide conditions
  showSearchBar: boolean = false; //Mobile only
  matSelectIsOpen: boolean = false;
  searchError: boolean = false;
  loading: boolean = false;

  //Form
  searchForm: UntypedFormGroup;

  //Export
  tableObj: IClaims_Table = defaultSSPClaimsTable;

  constructor(
    private fb: FormBuilder,
    private claimService: ClaimService,
    private dialog: MatDialog
  ) {
    this.searchForm = this.fb.group({
      category: ['', Validators.required],
      searchVal: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.claimService.getIsClaimSearchCompleted().subscribe(
      completed => {
        if (completed) {
          this.loading = false;
        }
      }
    );
  }

  toggleSearchBar() {
    this.showSearchBar = !this.showSearchBar;
  }

  toggleSelect() {
    this.matSelectIsOpen = !this.matSelectIsOpen;
  }

  trim() {
    if (this.searchVal.value) {
      this.searchVal.setValue(this.searchVal.value.trim());
    }
  }

  reset() {
    this.searchParams.emit({});
  }

  search() {
    this.loading = true;
    this.searchError = false;
    this.claimService.setIsClaimSearchCompleted(false);

    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    switch (this.category.value) {
      case 'claimNumber':
        this.searchParams.emit({ claimNumber: this.searchVal.value });
        break;
      case 'fileDate':
        this.searchParams.emit({ fileDate: this.searchVal.value });
        break;
      case 'totalPaidAmount':
        this.searchParams.emit({ paidAmount: this.searchVal.value });
        break;
      case 'trackingNumber':
        this.searchParams.emit({ trackingNumber: this.searchVal.value });
        break;
      case 'referenceNumber':
        this.searchParams.emit({ referenceNumber: this.searchVal.value });
        break;
      case 'receiver':
        this.searchParams.emit({ receiver: this.searchVal.value });
        break;
      default:
        this.loading = false;
        break;
    }

  }

  openExport() {
    let config = new MatDialogConfig();
    config = {  ...config,
      autoFocus: false,
      closeOnNavigation: true,
      width: '515px',
      data: this.tableObj
    }

    let dialogRef = this.dialog.open(ExportComponent, config);
    dialogRef.afterClosed().subscribe();
  }

  //Keeping this at the bottom because its ugly at the top
  searchCategories = [
    { value: 'claimNumber', label: 'Claim #' },
    { value: 'fileDate', label: 'File Date' },
    { value: 'totalPaidAmount', label: 'Total Paid Amount' },
    { value: 'trackingNumber', label: 'Tracking #/BOL' },
    { value: 'referenceNumber', label: 'Reference #' },
    { value: 'receiver', label: 'Receiver' }
  ];

  get searchVal() { return this.searchForm.controls.searchVal; }
  get category() { return this.searchForm.controls.category; }

  hasClaimAmountAccess(): boolean {
    const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    if (!userDetails) return false;
    
    const claimAccess = userDetails.claimAmountAccess !== undefined ? userDetails.claimAmountAccess : userDetails.claim_Amount_Access;
    return claimAccess !== false;
  }

  getFilteredSearchCategories() {
    return this.searchCategories.filter(category => {
      if (category.value === 'totalPaidAmount') {
        return this.hasClaimAmountAccess();
      }
      return true;
    });
  }
}
